module.exports = __webpack_public_path__ + "img/02.2da44f95.jpg";